import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const SVGComponent: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '39'}
        height={size != null ? size[1].toString() : '38'}
        viewBox="0 0 39 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
          .primaryTrain { fill: ${primaryColor != null ? primaryColor : '#A5D152'} }
          .secondaryTrain { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
        `}
        </style>
        <circle cx="19.3604" cy="19.0049" r="18.1865" className="primaryTrain" stroke="white" strokeWidth="1.5" />
        <path
          d="M14.5871 26.7307H23.9256C25.5212 26.7307 26.8201 25.4262 26.8201 23.8306V13.7923C26.8201 13.1373 26.501 12.5438 25.9579 12.2023C24.603 11.3625 23.1362 10.7859 21.5966 10.4947C20.824 10.3492 20.0458 10.2764 19.2899 10.2764C18.5677 10.2764 17.8343 10.3324 17.0673 10.4667C15.4773 10.7523 13.9601 11.3345 12.5604 12.2023C12.0174 12.5438 11.6926 13.1373 11.6926 13.7923V23.8306C11.6926 25.4262 12.9915 26.7307 14.5871 26.7307ZM15.3417 24.2434C14.7236 24.2434 14.222 23.7418 14.222 23.1237C14.222 22.5056 14.7236 22.004 15.3417 22.004C15.9598 22.004 16.4614 22.5056 16.4614 23.1237C16.4614 23.7418 15.9598 24.2434 15.3417 24.2434ZM23.1754 24.2434C22.5573 24.2434 22.0557 23.7418 22.0557 23.1237C22.0557 22.5056 22.5573 22.004 23.1754 22.004C23.7935 22.004 24.2951 22.5056 24.2951 23.1237C24.2951 23.7418 23.7935 24.2434 23.1754 24.2434ZM12.8123 14.4306H25.7004V19.4693H12.8123V14.4306Z"
          fill="white"
        />
        <path
          d="M24.9277 27.1406C24.7485 27.1966 24.5582 27.2414 24.3678 27.2582L24.7551 28.2189H13.9041L14.2847 27.275C14.0888 27.2638 13.8984 27.2302 13.7137 27.1742L11.7094 32.1626C11.6534 32.3026 11.7262 32.4649 11.8661 32.5265C12.0117 32.5825 12.1741 32.5153 12.2301 32.3697L12.9181 30.6636H25.7405L26.4281 32.3697C26.4729 32.4761 26.5793 32.5433 26.6857 32.5433C26.7249 32.5433 26.7585 32.5377 26.792 32.5265C26.9376 32.4649 27.0048 32.3026 26.9488 32.1626L24.9277 27.1406ZM13.1439 30.1038L13.6783 28.7788H24.9807L25.5148 30.1038H13.1439Z"
          fill="white"
        />
        <path
          d="M27.1595 6.21875H11.5031C11.3483 6.21875 11.2231 6.34395 11.2231 6.49868C11.2231 6.65341 11.3483 6.77861 11.5031 6.77861H19.0514V8.5644L19.0491 8.56454C18.2205 8.65974 17.4927 9.1692 17.112 9.8914C17.8398 9.77385 18.5452 9.71785 19.2787 9.71785C20.0345 9.71785 20.8071 9.78503 21.5685 9.91942C21.4509 9.68986 21.2942 9.47151 21.1094 9.28678C20.7012 8.8786 20.1759 8.62707 19.6112 8.56498V6.77861H27.1595C27.3142 6.77861 27.4394 6.65341 27.4394 6.49868C27.4394 6.34395 27.3142 6.21875 27.1595 6.21875Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SVGComponent;
